<router-outlet></router-outlet>
<app-message></app-message>
<p-toast [breakpoints]="{'769px': {width: '95%', right: '10px'}}" key="basic-message"></p-toast>
<app-loading></app-loading>